export default "__VITE_ASSET__vL58$1YJ__"